import { PhysicalProductItemErrorsType } from 'modules/stores/store/content/product/types/product-interface'
import {
  getPhysicalProductCheckoutErrorChecker,
  getThankYouErrorChecker,
  getThumbnailErrorChecker,
} from 'modules/stores/store/utils/get-error-checkers'
import { useFormErrorMessageInTabs } from 'modules/stores/store/utils/use-form-error-message-in-tabs'
import { PhysicalProductTabEnum, tabLocoKeys } from '../enum/physical-product-tab-enum'
import { getPhysicalProductError } from '../utls/get-physical-product-error'

export const useErrorMessageInTabs = () => {
  const { formErrorMessage: formErrorMessageCommon } = useFormErrorMessageInTabs()

  const getTabsWithErrors = ({
    errors,
  }: {
    errors: PhysicalProductItemErrorsType
  }): Record<PhysicalProductTabEnum, boolean> => {
    const hasThumbnailError = getThumbnailErrorChecker(errors)

    const hasCheckoutError = getPhysicalProductCheckoutErrorChecker(errors)

    const hasThankYouError = getThankYouErrorChecker(errors)

    const hasProductError = getPhysicalProductError(errors)

    return {
      [PhysicalProductTabEnum.thumbnail]: hasThumbnailError,
      [PhysicalProductTabEnum.checkout]: hasCheckoutError,
      [PhysicalProductTabEnum.physical_product]: hasProductError,
      [PhysicalProductTabEnum.thank_you]: hasThankYouError,
    }
  }

  const formErrorMessage = ({ errors }: { errors: PhysicalProductItemErrorsType }) => {
    const tabsErrorsMap = getTabsWithErrors({ errors })
    return formErrorMessageCommon({ tabsErrorsMap, tabsLocoKeys: tabLocoKeys })
  }

  return {
    getTabsWithErrors,
    formErrorMessage,
  }
}
